export function getFrontendBaseUrl() {
  if (typeof window === "undefined" || !window.location?.origin) {
    return undefined;
  }
  return window.location.origin;
}

/**
 * Keep payment checkout on the current origin when developing locally.
 * API may still return the cooperative public domain in payment_url.
 */
function localizePaymentUrl(url) {
  if (!url || typeof window === "undefined") {
    return url;
  }

  const host = window.location.hostname;
  const isLocal =
    host === "localhost" || host === "127.0.0.1" || host === "[::1]";
  if (!isLocal) {
    return url;
  }

  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.origin === window.location.origin) {
      return url;
    }
    return `${window.location.origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return url;
  }
}

export function redirectToMemberOnlinePayment(payload) {
  const data = payload?.data || payload || {};
  const url = data.payment_url || data.authorization_url;
  if (data.payment_reference) {
    sessionStorage.setItem("pending_payment_reference", data.payment_reference);
  }
  if (url) {
    window.location.href = localizePaymentUrl(url);
    return true;
  }
  return false;
}

export function feePreviewChannel(mode) {
  if (mode === "bank" || mode === "society_bank_transfer") {
    return "bank_transfer";
  }
  if (mode === "alatpay") {
    return "alatpay";
  }
  return "online";
}

export function isSocietyBankMode(mode) {
  return mode === "bank" || mode === "society_bank_transfer";
}

export function isPaystackMode(mode) {
  return mode === "paystack" || mode === "online";
}
